import Vue from 'vue';
import carSweepstakesWidget from './car-sweepstakes-widget/car-sweepstakes-widget.vue';
import store from '../common/js/vuex/store';
import carSweepstakesWidgetStore from '../applications/car-sweepstakes-widget/car-sweepstakes-widget-vuex';
if (!store.hasModule(['carSweepstakesWidget'])) {
	store.registerModule('carSweepstakesWidget', carSweepstakesWidgetStore);
}
Vue.component('car-sweepstakes-widget', carSweepstakesWidget);
